// MaleHormoneCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { HORM_M } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function MaleHormoneCard() {
  const { t } = useTranslation();

  const panel = {
    id: "hormone_male",
    title: t("card_male_hormone_title"),
    subtitle: t("card_male_hormone_desc"),
    biomarkers: t("card_male_hormone_markers"),
    price: "€ 149",
    image: HORM_M,
  };

  return <BasePackageCard panel={panel} />;
}